// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"OVHjx","property":"jzSac","grid":"L0l1A","row":"v8zMt","item":"SwCw8","icon":"HGhjG","circle":"y52oA"};